/* Microsoft Clarity Analytics — consent-gated über die Shopify Customer
   Privacy API. Lädt Clarity erst nach Analytics-Einwilligung und annotiert
   die Session mit dem Seitenkontext aus window.RM_CLARITY_CTX
   (inline in layout/theme.liquid gesetzt, da Liquid-Werte nötig). */

(function () {
  var CLARITY_ID = 'wdnhfl8pqv';
  var loaded = false;
  var contextApplied = false;

  window.rmClarity = function () {
    if (typeof window.clarity === 'function') {
      try {
        window.clarity.apply(window, arguments);
      } catch (e) {}
    }
  };

  function loadClarity() {
    if (loaded) return;
    loaded = true;
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', CLARITY_ID);
    applyContext();
  }

  function applyContext() {
    if (contextApplied) return;
    contextApplied = true;
    var ctx = window.RM_CLARITY_CTX || {};
    Object.keys(ctx).forEach(function (key) {
      var value = ctx[key];
      if (value === null || value === undefined || value === '') return;
      window.rmClarity('set', key, String(value));
    });
    if (ctx.page_type === 'product') {
      window.rmClarity('event', 'view_product');
    }
  }

  function hasAnalyticsConsent() {
    try {
      return (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (e) {
      return false;
    }
  }

  function init() {
    if (hasAnalyticsConsent()) {
      loadClarity();
      return;
    }
    document.addEventListener('visitorConsentCollected', function (event) {
      if (event.detail && event.detail.analyticsAllowed) {
        loadClarity();
      }
    });
  }

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target.closest('[name="checkout"], a[href*="/checkout"]');
      if (!target) return;
      window.rmClarity('event', 'checkout_started');
      window.rmClarity('set', 'checkout_entry', target.getAttribute('name') === 'checkout' ? 'cart_button' : 'direct_link');
      window.rmClarity('upgrade', 'checkout');
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      window.rmClarity('event', 'variant_selected');
      window.rmClarity('set', 'selected_variant_id', String(variant.id));
      if (variant.title) window.rmClarity('set', 'selected_variant_title', String(variant.title));
      if (typeof variant.price === 'number') {
        window.rmClarity('set', 'selected_variant_price', (variant.price / 100).toFixed(2));
      }
      window.rmClarity('set', 'selected_variant_available', variant.available ? 'yes' : 'no');
    });
  });
})();
